import { Buffer } from "buffer";
import { StyledEngineProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { persistor, store } from "./redux/store";
// import { Toaster } from 'react-hot-toast';
import ThemeProvider from "@/theme/themeProvider";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App.jsx";
import SettingsProvider from "./SettingsProvider.jsx";

import packageJson from "../package.json";
import "./locales/i18n";
import "./styles/iconfont.css";
import "./styles/index.less";

// sentry
// import './sentry'

window.appVersion = packageJson?.version;
console.log("version: ", packageJson?.version);

globalThis.Buffer = Buffer;

// loading chunk failed will auto reload page.
window.onerror = (message) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  }
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <StyledEngineProvider injectFirst>
    <SettingsProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </PersistGate>
      </ReduxProvider>
    </SettingsProvider>
  </StyledEngineProvider>
);
